module.exports = __webpack_public_path__ + "static/media/vip-room.6775a341.png";